import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";

import { SecondaryStyle } from "../fonts";

import RD from "../assets/Page6RD.webp";
import RC from "../assets/Page6RC.webp";
import RB from "../assets/Page6RB.webp";
//@ts-ignore
import RA from "../assets/Page6RA.mp4";
//@ts-ignore
import LA from "../assets/Page6LA.mp4";

const Page6 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={9.1}>
                <Grid
                  container
                  direction={"row"}
                  sx={{ height: { xs: "46vh", sm: "100%" } }}
                >
                  {/* LD/LA/*/}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: ".1vh solid #fff",
                      },
                      borderTop: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      height: { xs: "45vh", sm: "100%vh" },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: { xs: "45vh", sm: "75vh" },
                        objectFit: "cover",
                      }}
                      src={LA}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                </Grid>

                {/* LB */}
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",

                    pb: { xs: 1.5 },
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      ...SecondaryStyle,
                      textAlign: "justify",
                      "@media (orientation: landscape)": {
                        fontSize: { xs: "1vw", md: "1vw", lg: "1vw" },
                        lineHeight: { xs: "1.1vw", md: "1.1vw", lg: "1.1vw" },
                        paddingTop: "2vw",
                        px: { xs: "2vh", sm: "2vw" },
                      },
                      "@media (orientation: portrait)": {
                        fontSize: {
                          xs: "1.7vh",
                          sm: "1vh",
                        },
                        lineHeight: {
                          xs: "2vh",
                          sm: "1.65vh",
                          md: "1.7vh",
                          lg: "2vh",
                        },
                        paddingTop: {
                          xs: "1vh",
                          sm: "2.2vh",
                          md: "1.2vh",
                          lg: "0vh",
                        },
                        px: { xs: "1.5vh", sm: "4vh" },
                      },
                    }}
                  >
                    The private fenced backyard is a tranquil retreat, featuring
                    a hot tub nook perfect for unwinding after a long day. The
                    beautifully maintained perennial garden adds a touch of
                    nature's charm to the space. The detached garage has been
                    transformed into a versatile workshop, while still offering
                    room for one vehicle. This outdoor oasis effortlessly blends
                    functionality and relaxation, creating an escape within the
                    comfort of your home.
                  </Typography>
                </Grid>
              </Grid>
              {/* LC/LB */}
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    maxHeight: { sm: "100%" },
                  }}
                >
                  {/**RC */}

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      height: {
                        xs: "46vh",
                        sm: "50vh",
                      },
                      maxHeight: { xs: "100%", sm: "50vh" },
                      backgroundImage: `url('${RD}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRadius: { xs: "16px", sm: "0vh" },
                    }}
                  />

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderTop: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      height: {
                        xs: "45.5vh",
                        sm: "100%",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: { xs: "45vh", sm: "50vh" },
                        objectFit: "cover",
                      }}
                      src={RA}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    borderTop: "0.8vh solid #fff",
                    height: {
                      sm: "100%",
                    },
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "46vh", sm: "50vh" },

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      backgroundImage: `url('${RC}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderRadius: { xs: "16px", sm: "0vh" },
                      height: { xs: "46vh", sm: "50vh" },

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      backgroundImage: `url('${RB}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page6;
